import { createSlice } from "@reduxjs/toolkit";

const launchPadlayoutSlice = createSlice({
  name: "launchPadLayout",
  initialState: {
    isPlayerLoaded: false,
    isSiteReady: false,
    isPageLoaderAnimationFinished: false,
    showLoader: false,
    //Flag to change between Default(30s) and On Demand(1s) time interval for the updates
    updatesOnDemandInterval: false,
    // Arrays of all new completed courses, skillpaths and jobs to show the completion modal for each one
    pendingCompletedSkillpaths: [],
    pendingCompletedCourses: [],
    pendingCompletedJobDomains: [],
  },
  reducers: {
    resetState(state, action) {
      state.isSiteReady = false;
      state.isPageLoaderAnimationFinished = false;
    },
    setState(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    // Add new items to the course, skillpath and job domains arrays if they are not already present
    // and set pending to true for each new item
    setPendingCompletedSkillpaths: (state, action) => {
      const newItems = action.payload
        .filter(
          (item) =>
            !state.pendingCompletedSkillpaths.some(
              (existingItem) => existingItem.id === item.id
            )
        )
        .map((item) => ({ ...item, pending: true }));
      state.pendingCompletedSkillpaths = [
        ...state.pendingCompletedSkillpaths,
        ...newItems,
      ];
    },
    setPendingCompletedCourses: (state, action) => {
      const newItems = action.payload
        .filter(
          (item) =>
            !state.pendingCompletedCourses.some(
              (existingItem) => existingItem.courseId === item.courseId
            )
        )
        .map((item) => ({ ...item, pending: true }));
      state.pendingCompletedCourses = [
        ...state.pendingCompletedCourses,
        ...newItems,
      ];
    },
    setPendingCompletedJobDomains: (state, action) => {
      const newItems = action.payload
        .filter(
          (item) =>
            state.pendingCompletedJobDomains.findIndex(
              (existingItem) => existingItem.id === item.id
            ) < 0
        )
        .map((item) => ({ ...item, pending: true }));
      state.pendingCompletedJobDomains = [
        ...state.pendingCompletedJobDomains,
        ...newItems,
      ];
    },
    // Set pending to false for each popup id the user has already seen for each array
    updatePendingCompletedSkillpath: (state, action) => {
      const { skillpathId, pending } = action.payload;
      state.pendingCompletedSkillpaths = state.pendingCompletedSkillpaths.map(item =>
        item.id === skillpathId ? { ...item, pending } : item
      );
    },
    updatePendingCompletedCourse: (state, action) => {
      const { courseId, pending } = action.payload;
      state.pendingCompletedCourses = state.pendingCompletedCourses.map(item =>
        item.courseId === courseId ? { ...item, pending } : item
      );
    },
    updatePendingCompletedJobDomain: (state, action) => {
      const { domainId, pending } = action.payload;
      state.pendingCompletedJobDomains = state.pendingCompletedJobDomains.map(item =>
        item.id === domainId ? { ...item, pending } : item
      );
    },

  },
});

export const launchPadLayoutActions = launchPadlayoutSlice.actions;

export default launchPadlayoutSlice.reducer;